(function() {
  var $dropshipAllowField = $('.ph-lumifyparent__billingform'),
      signUpError = 'ph-signup__error',
      shippingForm = 'ph-lumifyparent__diffbilling',
      formFieldError = 'ph-form_field_error',
      $addressField = $('.' + shippingForm),
      postCodeInput = $addressField.find('#postalCode'),
      formatErrorText = postCodeInput.closest('.ph-inputData').attr('data-formatError'),
      inputData = 'ph-inputData',
      emptyValue = 'ph-register__emptyvalue',
      lumifyInput = 'ph-lumifyparent__billingform input.ph-lumifyinput',
      isValid = true,
      paymentPageValidationCheckbox = false,
      isPostalValid = true,
      spinner = 'ph-spinnerorder';

  function billingAddressDifferent() {
    var billingingDifferent = document.querySelector('.ph-add_different_billing').checked;

    if (billingingDifferent === true) {
      document.querySelector('.ph-lumifypayment__shippingaddress').style.display = 'block';
    } else {
      document.querySelector('.ph-lumifypayment__shippingaddress').style.display = 'none';
    }
  }

  function ajaxCall() {
    var $countryVal = $('#ph-country'),
        $lineTwo = $('#ph-addressLine2'),
        dataObj = {
          line1: $dropshipAllowField.find('.ph-forminput[name=line1]').val(),
          line2: $dropshipAllowField.find('.ph-forminput[name=line2]').val(),
          townCity: $dropshipAllowField.find('.ph-forminput[name=townCity]').val(),
          country: $dropshipAllowField.find('.ph-forminput[name=country]').val(),
          regionIso: $dropshipAllowField.find('.ph-forminput[name=regionIso]').val(),
          postcode: $dropshipAllowField.find('.ph-forminput[name=postalCode]').val()
        };

    if ($('.ph-isOneStore').html()) {
      dataObj.houseno = $dropshipAllowField.find('.ph-forminput[name=apartment]').val();
    }

    if ($countryVal.length <= 0 || $lineTwo.length <= 0) {
      dataObj.country = null;
      dataObj.line2 = null;
    }

    $.ajax({
      type: 'POST',
      url: '/anonymousPayment/summary/createBillingAddressForAnonymous.json',
      dataType: 'json',
      data: dataObj
    });
  }

  function wrongPostalCode() {
    var countryField = '';

    if ($('#country').length > 0) {
      countryField = '#country';
    }

    if (ACC.validation.postalCode(postCodeInput.val(), countryField)) {
      postCodeInput.closest('.' + signUpError).addClass(formFieldError);
      postCodeInput.closest('.' + inputData).find('.' + emptyValue).text(formatErrorText);
      isPostalValid = false;
    } else {
      postCodeInput.closest('.' + signUpError).removeClass(formFieldError);
      postCodeInput.closest('.' + inputData).find('.' + emptyValue).text('');
      isPostalValid = true;
    }
  }

  function inputValidation($othis) {
    var errormsgValue = $($othis).parents('.ph-inputData').attr('data-emptyContent');

    isValid = true;

    if ($.trim($($othis).val()) === '' || $($othis).val() === null) {
      $($othis).parents('.' + signUpError).addClass('ph-form_field_error form_field_error');
      $($othis).parents('.' + signUpError).find('.ph-register__emptyvalue').text(errormsgValue);
      isValid = false;
    } else {
      $($othis).parents('.' + signUpError).removeClass('form_field_error ph-form_field_error');
      $($othis).parents('.' + signUpError).find('.ph-register__emptyvalue').text('');
    }
  }

  $(document).on('blur', '#ph-postalCodelumify', function() {
    var postalCodeId = $(this).attr('id');

    ACC.registerPage.isEmptyValue(postalCodeId);

    if (postCodeInput.val() !== '') {
      wrongPostalCode();
    }
  });

  function validationLumifyBillingForm() {
    $('.' + lumifyInput).each(function() {
      var $herethis = $(this);

      inputValidation($herethis);
    });

    $('.' + lumifyInput).each(function() {
      if ($.trim($(this).val()) === '' || $(this).val() === null) {
        isValid = false;

        return false;
      }

      return true;
    });

    if (postCodeInput.val() !== '') {
      wrongPostalCode();
    }

    return isValid;
  }

  function checkBoxValidationSubmit() {
    $('.terms').find(ACC.osCheckout.checkValidation).each(function() {
      if ($('.ph-checkValidation input[type=checkbox]:checkbox:checked').length === $('.ph-checkValidation input[type=checkbox]').length) {
        paymentPageValidationCheckbox = true;
      } else if (!$(this).find(ACC.osCheckout.inputBoxCheckBox).is(':checked')) {
        paymentPageValidationCheckbox = false;
        $(this).find('.ph-errorPayment').removeClass('hiddenClass');
      }
    });

    if ($('#purchaseOnBehalf').is(':checked') === true) {
      $('#purchaseOnBehalfValue').val('true');
    } else {
      $('#purchaseOnBehalfValue').val('false');
    }
  }

  $(document).on('click', '#ph-lumifyparent__submit', function() {
    var checkval = $('#add_different_billing').prop('checked');

    if (checkval === true) {
      var returnVal = validationLumifyBillingForm();

      if (returnVal === true && isPostalValid === true) {
        checkBoxValidationSubmit();

        if (paymentPageValidationCheckbox === true) {
          $('.' + spinner).removeClass('hidden');
          $('#placeOrderForm1').submit();
          $(this).addClass('ph-disabledbutton');
        }
      }
    } else {
      checkBoxValidationSubmit();

      if (paymentPageValidationCheckbox === true) {
        $('.' + spinner).removeClass('hidden');
        $('#placeOrderForm1').submit();
        $(this).addClass('ph-disabledbutton');
      }
    }
  });

  $(document).on('click', '.ph-anonymous_payNow', function() {
    checkBoxValidationSubmit();

    if (paymentPageValidationCheckbox === true) {
      $('.ph-anonymous_payNow').removeAttr('type').attr('type', 'submit');
      $('.' + spinner).removeClass('hidden');
      $('#termsFlag').val($('#Terms1').is(':checked'));
      $('#adendumFlag').val($('#lumifyAddendum1').is(':checked'));
      $('#aedadendumFlag').val($('#aedAddendum').is(':checked'));
      $('#purchaseOnBehalfVal').val($('#purchaseOnBehalfValue').val());
      $('#anonymouspaynowForm').submit();
      $(this).addClass('ph-disabledbutton');
    }
  });

  $('.terms').find(ACC.osCheckout.checkValidation).on('change', function() {
    $('.terms').find(ACC.osCheckout.checkValidation).each(function() {
      if ($(this).find(ACC.osCheckout.inputBoxCheckBox).is(':checked')) {
        $(this).find('.ph-errorPayment').addClass('hiddenClass');
      }
    });
  });

  $(document).on('blur', '.ph-lumifyparent__billingform input.ph-lumifyinput', function() {
    var $othis = $(this);

    inputValidation($othis);

    $('.' + lumifyInput).each(function() {
      if (isValid) {
        if ($.trim($(this).val()) === '' || $(this).val() === null) {
          isValid = false;

          return false;
        }
      }

      return true;
    });

    if (postCodeInput.val() !== '') {
      wrongPostalCode();
    }

    if (isValid === true && isPostalValid === true) {
      ajaxCall();
    }
  });

  $(document).on('click', '.ph-lumifyparent__diffbilling .ph-add_different_billing', function() {
    billingAddressDifferent();
  });

  function anonymousShowHideOnChange(paymentTypeFromCart) {
    var paymentButton = 'ph-lumifyparent__submit';

    if (paymentTypeFromCart === 'CARD') {
      $('.checkout_summary_flow').addClass('cardtype');
      $('#checkout_summary_payment_div').show();
      $('.ph-lumifypayment__billingparent').hide();
      $('.ph-lumifyparent__diffbilling').hide();
      $('#' + paymentButton).hide();
    } else {
      $('.checkout_summary_flow').removeClass('cardtype');
      $('#checkout_summary_payment_div').hide();
      $('.ph-lumifypayment__billingparent').show();
      $('.ph-lumifyparent__diffbilling').show();
      $('#' + paymentButton).show();
    }
  }

  $(document).on('change', 'input:radio[name=\'anonymousPaymentType\']', function() {
    var paymentTypeSelected = $('input:radio[name=\'anonymousPaymentType\']:checked').val();

    $.ajax({
      type: 'POST',
      url: '/anonymousPayment/summary/setPaymentType.json',
      dataType: 'json',
      data: {
        paymentType: paymentTypeSelected
      },
      success: function() {
        anonymousShowHideOnChange(paymentTypeSelected);
      }
    });
  });

  $(document).on('blur', '.ph-anonymouspurchase', function() {
    $('.' + spinner).removeClass('hidden');

    var purchaseOrderNumber = $('input[name=\'anonymousPurchaseOrderNumber\']').val();

    $.ajax({
      type: 'POST',
      url: '/anonymousPayment/summary/setPurchaseOrderNumber.json',
      dataType: 'json',
      data: {
        purchaseOrderNumber: purchaseOrderNumber
      },
      success: function() {
        $('.' + spinner).addClass('hidden');
      }
    });
  });

  function autoSelectedPayment() {
    $.ajax({
      type: 'GET',
      url: '/anonymousPayment/summary/getCheckoutCart.json',
      dataType: 'json',
      success: function(anonymousCheckoutCartData) {
        var paymentTypeFromCart = anonymousCheckoutCartData.paymentType.code;

        $('input:radio[name=\'anonymousPaymentType\'][value=' + paymentTypeFromCart + ']').attr('checked', true);
        anonymousShowHideOnChange(paymentTypeFromCart);
      }
    });
  }

  window.addEventListener('DOMContentLoaded', function() {
    if ($('.ph-page-AnonymousPaymentPage').length > 0) {
      autoSelectedPayment();

      var isIdentifyNumberEntered = $.trim(sessionStorage.getItem('isIdentifyNumberEntered'));

      if (isIdentifyNumberEntered === 'yes') {
        $('.ph-paymentnpilabel').removeClass('hidden');
      }
    }
  });
})();
